import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ startTime, durationMinutes = 45 }) =>
{
    const [timeRemaining, setTimeRemaining] = useState(0);

    useEffect(() =>
    {
        if (!startTime) return; // Exit if no start time is provided

        const start = new Date(startTime);
        const totalDuration = durationMinutes * 60; // Total duration in seconds

        // Function to update the timer
        const tick = () =>
        {
            const now = new Date();
            const elapsedSeconds = Math.floor((now - start) / 1000);
            const secondsLeft = Math.max(totalDuration - elapsedSeconds, 0);
            setTimeRemaining(secondsLeft);
        };

        // Initialize immediately
        tick();

        // Update every second
        const intervalId = setInterval(tick, 1000);

        // Clean up the interval on unmount
        return () => clearInterval(intervalId);
    }, [startTime, durationMinutes]);

    // Formatting time as minutes:seconds
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;

    return (
        <div>
            <p>Time remaining: {formattedTime}</p>
        </div>
    );
};

export default CountdownTimer;